import { mapState } from 'vuex';

export default {
	computed: {
		...mapState(['vhkId'])
	},
	watch: {
		sendSucceeded(val) {
			if (val) {
				this.$gtm.trackEvent({
					event: 'callbackRequestSuccess',
					vhk: this.vhkId
				});
			}
		},
		sendFailed(val) {
			if (val) {
				this.$gtm.trackEvent({
					event: 'callbackRequestFailed'
				});
			}
		}
	}
};
